import { Link } from 'gatsby-plugin-react-i18next'
import { Picture } from '../Picture'
import React from 'react'

function getRandomVariant() {
    const variants = [
        'bg-gradient-to-b bg-[#27A0CB] from-[#33E4A5] to-[#1A57F3]',
        'bg-gradient-to-b  bg-[#B52DAB] from-[#7C3EFF] to-[#F31A4E]',
        'bg-gradient-to-b bg-[#3061FF] from-[#3F97FF] to-[#1C17FF]',
        'bg-gradient-to-b bg-[#9933FF] from-[#EF56A3] to-[#841AF3]',
        'bg-gradient-to-b bg-[#FA8324] from-[#FFA63A] to-[#F25700]',
        'bg-gradient-to-b bg-[#B83BDE] from-[#EF56A3] to-[#841AF3]',
    ]

    const randomIndex = Math.floor(Math.random() * variants.length)
    return variants[randomIndex]
}

export const BlogCard = (props: {
    path: string
    title: string
    description?: string
    picture?: string
}) => {
    return (
        <Link
            to={props.path}
            className="w-full gap-3 flex flex-col rounded-2xl shadow-md p-3 cursor-pointer"
        >
            <div
                className={`w-full  h-[180px] py-2 rounded-xl ${getRandomVariant()} `}
            >
                <Picture
                    alt={props.title}
                    picture={props.picture}
                    className="h-full"
                />
            </div>
            <div className="text-left">
                <div className="font-bold text-xl">{props.title}</div>
                <div>{props.description}</div>
            </div>
        </Link>
    )
}
